import React from 'react'
import AnswerCard from '../AnswerCard/NewAnswerCard';
import PdfAnswerCard from '../AnswerCard/PdfAnswerCard';
import ThreadAnswerCard from '../AnswerCard/ThreadAnswerCard';
import VideoAnswerCard from '../AnswerCard/VideoAnswerCard';

export default function Answers({answer,question}) {
  return (
    <>
      {(question.docType === "expertqa" || question.docType === undefined || question.docType === 'Email') && (
        <AnswerCard question={question} answer={answer} />
      )}
      {(question.docType === "Pdf" ||
        question.docType === "Image" ||
        question.docType === "urlcrawl") && (
        <PdfAnswerCard question={question} answer={answer} />
      )}
      {question.docType === "Thread" && (
        <ThreadAnswerCard question={question} answer={answer} />
      )}
      {question.docType === "Video" && (
        <VideoAnswerCard questionabc={question} answerabc={answer} />
      )}
    </>
  );
}
